import * as React from 'react';
import { StyledTabs, StyledTab } from './components/StyledTabs';
import { useIntl } from 'react-intl';
import { Icon } from 'components/Icon';
import scaleImage from 'static/icons/balance-scale.svg';
import guestsImage from 'static/icons/guests.svg';

interface ComponentProps {
  onTabChange: (value: string) => void;
  children: React.ReactElement;
  initialValue?: string;
}

// todo refactor or rename to something else, not generic ui component with hardcoded labels
const TabContainer: React.FunctionComponent<ComponentProps> = (props) => {
  const intl = useIntl();
  const { initialValue, onTabChange, children } = props;
  const [value, setValue] = React.useState(initialValue || 'total');

  React.useEffect(() => {
    if (value !== initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);

  const handleChange = (event: React.ChangeEvent, newValue: string) => {
    setValue(newValue);
    onTabChange(newValue);
  };

  return (
    <>
      <StyledTabs value={value} onChange={handleChange}>
        <StyledTab
          label={intl.formatMessage({ id: 'report.totalFoodwaste.title' })}
          icon={<Icon icon={scaleImage} />}
          value='total'
        />
        <StyledTab
          label={intl.formatMessage({ id: 'report.foodwaste.perGuest.title' })}
          icon={<Icon icon={guestsImage} />}
          value='per-guest'
        />
      </StyledTabs>
      {children}
    </>
  );
};

export default TabContainer;
